/**
 * Created by Christof Sander on 25.01.2017.
 */

const utils = require('../../../lib/utils')

module.exports = {
	config: {
		resourceRegisterKey: 'imageAssignmentDetails'
	},

	methods: {
		onChange: function(data){
			// TODO: REMOVE BROKEN IMAGE CLENAUP
			if(
				this.resourceData.data &&
				this.resourceData.data.relationships &&
				this.resourceData.data.relationships.lang &&
				this.resourceData.data.relationships.lang.data &&
				!Array.isArray(this.resourceData.data.relationships.lang.data)
			){
				var dataIndex;
				var newData = [];
				for(dataIndex in this.resourceData.data.relationships.lang.data){
					if(dataIndex == parseInt(dataIndex)){
						newData.push(this.resourceData.data.relationships.lang.data[dataIndex]);
					}
				}
				this.resourceData.data.relationships.lang.data = newData;
			}

			// set new data
			utils.refMerge(this.resourceData, data);
		}
	}
};
